/* eslint-disable react/forbid-prop-types */
import React from 'react'
import { any, string } from 'prop-types'
import { Route } from '@fs/zion-router'
import { useUser } from '@fs/zion-user'
import { usePermission } from '@fs/zion-permissions'
import LoadingSpinner from '../shared/components/LoadingSpinner'

export default function PermissionRouteWithFallback({
  component: Component,
  path,
  exact,
  fallback: Fallback,
  children,
  requirePersonalData,
  permissionName,
  permissionContext,
}) {
  const { signedIn, userLoading } = useUser()
  const [hasPermission, permissionStatus] = usePermission(permissionName, permissionContext)

  // usePermission starts out [false, 'loading'], so rendering off the boolean alone flashes the
  // Unauthorized fallback at permitted users before the check resolves.
  const loading = userLoading || permissionStatus === 'loading'

  return (
    <Route
      exact={exact}
      path={path}
      render={(props) => (
        <>
          {loading && <LoadingSpinner size="lg" />}
          {!loading && signedIn && hasPermission && <Component {...props} />}
          {!loading && (!signedIn || !hasPermission) && <Fallback {...props} />}
        </>
      )}
      requirePersonalData={requirePersonalData}
    >
      {children}
    </Route>
  )
}

PermissionRouteWithFallback.propTypes = {
  children: any,
  component: any,
  fallback: any.isRequired,
  permissionName: string.isRequired,
  permissionContext: string.isRequired,
}
